export var TimeScale;
(function (TimeScale) {
    TimeScale["Hours"] = "hours";
    TimeScale["Minutes"] = "minutes";
    TimeScale["Seconds"] = "seconds";
})(TimeScale || (TimeScale = {}));
